var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "el-form",
          {
            ref: "coverageForm",
            staticClass: "form-container",
            attrs: {
              model: _vm.coverageForm,
              rules: _vm.rules,
              autocomplete: "on",
              "label-position": "left",
              size: "mini",
            },
          },
          [
            _c(
              "el-row",
              [
                _c("FipStateOptions", {
                  attrs: { vendorId: _vm.getVendorId },
                  model: {
                    value: _vm.coverageForm,
                    callback: function ($$v) {
                      _vm.coverageForm = $$v
                    },
                    expression: "coverageForm",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("VendorInspectionTypes", {
                  model: {
                    value: _vm.coverageForm,
                    callback: function ($$v) {
                      _vm.coverageForm = $$v
                    },
                    expression: "coverageForm",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "text-align": "center", "margin-top": "10px" },
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("Cancel")]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
          [_vm._v("Add Coverage Area")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }